module.exports = __webpack_public_path__ + "static/media/D_10.099d6e60.png";